// 📁 src/pages/Dashboard.jsx
// ✅ VERSIÓN SIMPLIFICADA USANDO DashboardLayout
import React from "react";
import { useAuth } from '../context/AuthContext.jsx';

// Layout y componentes principales
import DashboardLayout from '../components/DashboardLayout.jsx';
import DashboardCanvas from '../components/DashboardCanvas.jsx';
import SEOHead from '../components/SEOHead.jsx';

const Dashboard = ({ sidebarVisible, setSidebarVisible }) => {
  const { loading } = useAuth();

  // El DashboardLayout maneja toda la lógica

  // Loading state
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <p className="text-lg text-gray-700">Cargando...</p>
      </div>
    );
  }

  return (
    <>
      <SEOHead 
        title="Dashboard - Edutech Pulse Lab"
        robots="noindex, nofollow"
      />
      <DashboardLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}>
        <DashboardCanvas />
      </DashboardLayout>
    </>
  );
};

export default Dashboard;